import { ConfigurableFocusTrapFactory } from '@angular/cdk/a11y';
import {
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-table-filter-serverside',
    templateUrl: './table-filter-serverside.component.html',
    styleUrls: ['./table-filter-serverside.component.scss'],
    standalone: false
})
export class TableFilterServersideComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() objPosition: any;
  @Input() searchLabel: any;
  @Input() columnRowData = [];
  @Input() columnRowDataBackup = [];
  @Input() filtersOnDashboard = [];

  @Output() searchKeyword = new EventEmitter();
  @Output() closeFilterOverlay = new EventEmitter();

  @ViewChild('tableFilterServer', { static: false }) tableFilter: ElementRef;
  elm: HTMLElement;
  queryField: UntypedFormControl = new UntypedFormControl();

  optionList = [];
  searchTermList = [];
  backupOptionList = [];
  selectedSearchData = [];
  isSelectedAll = false;
  constructor(
    private el: ElementRef,
    private focusTrap: ConfigurableFocusTrapFactory,
  ) {}

  
  @HostListener('window:keyup', ['$event']) 
  keyFunc(event) {
    if (event.code === 'Escape') this.closeFilter();
  }

  ngOnChanges() {
    const filterIndex = this.filtersOnDashboard.findIndex(
      (el) => el.filterOn === this.searchLabel.filterOn
    );
    console.log(this.searchLabel, filterIndex);
    if (this.filtersOnDashboard[filterIndex]) {
      this.optionList = [...this.filtersOnDashboard[filterIndex].filterNames];
    }
    this.backupOptionList = [...this.optionList];
    this.optionList.forEach((el) => {
      if (el['isSelected']) {
        const e = { source: { value: el.name }, checked: true };
        this.setSearchValue(e);
      }
    });
    this.isSelectedAll = this.optionList.every((x) => x.isSelected === true);
  }

  ngAfterViewInit(): void {
    document.body.appendChild(this.el.nativeElement);
    this.setFocusTrap();
  }

  ngOnInit(): void {
    this.searchData();
  }
  
  searchData() {
    this.queryField.valueChanges
      .pipe(
        // debounceTime(100),
        distinctUntilChanged()
      )
      .subscribe((result) => {
        // this.searchKeyword.emit(result)
        console.log(result);
        if (result) {
          this.optionList = this.backupOptionList.filter((x) =>
            x.name.toLowerCase().includes(result.toLowerCase())
          );
        } else {
          this.optionList = [...this.backupOptionList];
        }
      });
  }

  closeFilter() {
    this.closeFilterOverlay.emit('');
  }

  getOptionvalue(opt) {
    const value = opt.name.trim();
    if (value) {
      return opt.name;
    } else {
      return '(Blank)';
    }
  }

  selectDeselectAll(e) {
    if (e.checked) {
      // this.isSelectedAll = true;
      this.searchTermList = [];
      this.optionList.forEach((options) => {
        options['isSelected'] = true;
        const e = { source: { value: options.name }, checked: true };
        this.setSearchValue(e);
      });
    } else {
      // this.isSelectedAll = false;
      this.searchTermList = [];
      this.optionList.forEach((options) => {
        options['isSelected'] = false;
        const e = { source: { value: options.name }, checked: false };
        this.setSearchValue(e);
      });
    }
  }

  isSelected() {}

  setSearchValue(e, i = -1) {
    if (i > -1) {
      this.optionList[i].isSelected = e.checked;
      this.optionList = [...this.optionList];
    }
    const data = {
      filterValues: e.source.value,
      columnId: this.searchLabel.filterOn,
      priority: 0,
    };
    if (e.checked) {
      let index = this.searchTermList.findIndex(
        (x) => x.filterValues === e.source.value
      );
      if (index == -1) {
        this.searchTermList.push(data);
      }
    } else {
      let index = this.searchTermList.findIndex(
        (x) => x.filterValues === e.source.value
      );

      if (index > -1) {
        this.searchTermList.splice(index, 1);
        console.log('this.searchTermList re ', this.searchTermList);
      }
    }
  }

  searchOptionList(index, item) {
    return item.name;
  }

  searchApply() {
    console.log('button click');
    let filterValueList = this.formatFilterData();
    console.log(this.searchTermList);
    console.log(filterValueList);
    this.selectedSearchData.push(filterValueList);
    // this.dataSharingService.shareFilterColumnData(this.searchTermList);
    // this.closeFilterOverlay.emit("")
    // this.searchKeyword.emit(this.searchTermList)
    this.searchKeyword.emit(this.selectedSearchData);
  }

  formatFilterData() {
    let obj = { columnId: this.searchLabel.filterOn, filterValues: '' };
    this.searchTermList.forEach((data, i) => {
      if (obj['filterValues']) {
        obj['filterValues'] += data.filterValues + ',';
      } else {
        obj['filterValues'] = data.filterValues + ',';
      }
    });
    obj['filterValues'] = obj['filterValues'].slice(0, -1);
    return obj;
  }

  ngOnDestroy(): void {
    this.el.nativeElement.remove();
    // const filterBtn = document.getElementById('filter-btn');
    // filterBtn.focus();
  }

  setFocusTrap() {
    const focusTrap = this.focusTrap.create(this.tableFilter.nativeElement);
    focusTrap.focusInitialElement();
  }
}
